export default __webpack_public_path__ + "static/media/newlogo.04eccb43.jpg";